document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("[data-catalog-grid]").forEach((grid) => {
    const page = grid.closest(".catalog-page");
    const searchInput = page && page.querySelector(".catalog-search input");
    const sortSelect = page && page.querySelector(".catalog-sort select");
    const count = page && page.querySelector("[data-catalog-count]");
    const cards = Array.from(grid.querySelectorAll("[data-product-card]"));

    if (!page || cards.length === 0) return;

    const applyCatalogState = () => {
      const query = (searchInput && searchInput.value.trim().toLowerCase()) || "";
      let visibleCards = cards.filter((card) => {
        const haystack = `${card.dataset.productTitle || ""} ${card.dataset.productCategory || ""}`;
        const isVisible = haystack.includes(query);
        card.hidden = !isVisible;
        return isVisible;
      });

      if (sortSelect) {
        const mode = sortSelect.value;
        visibleCards = visibleCards.sort((a, b) => {
          const aPrice = Number(a.dataset.productPrice || 0);
          const bPrice = Number(b.dataset.productPrice || 0);
          if (mode === "Preis aufsteigend") return aPrice - bPrice;
          if (mode === "Preis absteigend") return bPrice - aPrice;
          return cards.indexOf(a) - cards.indexOf(b);
        });
        visibleCards.forEach((card) => grid.appendChild(card));
      }

      if (count) {
        const total = visibleCards.length;
        count.textContent = `${total} ${total === 1 ? "Produkt" : "Produkte"} gefunden`;
      }
    };

    if (searchInput) searchInput.addEventListener("input", applyCatalogState);
    if (sortSelect) sortSelect.addEventListener("change", applyCatalogState);
    applyCatalogState();
  });
});
